import { toast } from "react-toastify";
import { api } from "../Configurations/axios";

//GET para obter todos os resumos de custos por pleaId
const GetAllPleaSummaryCostsByPleaId = async (pleaId: string) => {
    try {
        console.log("Making request to API with pleaID:", pleaId)
        const result = await api.get(`/api/PleaSummaryCosts/GetAllPleaSummaryCostsByPleaId`, {
            params: { pleaId }
        });
        console.log("API response:", result);
        return result.data;
    } catch (error: any) {
        console.error("API error details:", error.response);
        // toast.error("Erro ao buscar resumo de custos");
        toast.error(error.response?.data?.message || "Erro ao buscar resumo de custos");
        throw Error
    }
};

//GET para obter resumo de custos por versão e pleaId
const GetPleaSummaryCostsByVersionAndPlea = async (pleaId: string, version: number) => {
    try {
        const result = await api.get(`/api/PleaSummaryCosts/GetPleaSummaryCostsByVersionAndPlea?pleaId=${pleaId}&version=${version}`);
        return result.data;
    } catch (error: any) {
        toast.error("Erro ao buscar resumo de custos por versão");
        throw new Error(error.response?.data || "Erro desconhecido");
    }
};

//POST para criar novo resumo de custos
const CreatePleaSummaryCost = async (data: any) => {
    try {
        const result = await api.post("/api/PleaSummaryCosts/Create", data);
        toast.success("Resumo de custos criado com sucesso");
        return result.data;
    } catch (error: any) {
        toast.error("Erro ao criar resumo de custos");
        throw new Error(error.response?.data || "Erro desconhecido");
    }
};

//PUT para editar resumo de custos existente
const EditPleaSummaryCost = async (data: any) => {
    try {
        const result = await api.put("/api/PleaSummaryCosts/Edit", data);
        toast.success("Resumo de custos atualizado com sucesso");
        return result.data;
    } catch (error: any) {
        toast.error("Erro ao atualizar resumo de custos");
        throw new Error(error.response?.data || "Erro desconhecido");
    }
};

//DELETE para remover resumo de custos
const DeletePleaSummaryCost = async (data: any) => {
    try {
        const result = await api.delete("/api/PleaSummaryCosts/Delete", { data });
        toast.success("Resumo de custos excluído com sucesso");
        return result.data;
    } catch (error: any) {
        toast.error("Erro ao excluir resumo de custos");
        throw new Error(error.response?.data || "Erro desconhecido");
    }
};

//POST upload de arquivos de resumo de custos
const UploadPleaSummaryCosts = async (file: File, userEmail: string, pleaId: string) => {
    try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("userEmail", userEmail);
        formData.append("pleaId", pleaId);

        const result = await api.post("/api/PleaSummaryCosts/Upload", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        toast.success("Arquivo de resumo de custos enviado com sucesso");
        return result.data;
    } catch (error: any) {
        toast.error("Erro ao enviar arquivo de resumo de custos");
        throw new Error(error.response?.data || "Erro desconhecido");
    }
};

//GET download do modelo de resumo de custos
const DownloadPleaSummaryCostsModel = async () => {
    try {
        const result = await api.get("/api/PleaSummaryCosts/DownloadModel", {
            responseType: 'blob'
        });
        return result.data;
    } catch (error: any) {
        toast.error("Erro ao baixar modelo de resumo de custos");
        throw new Error(error.response?.data || "Erro desconhecido");
    }
};

export {
    GetAllPleaSummaryCostsByPleaId,
    GetPleaSummaryCostsByVersionAndPlea,
    CreatePleaSummaryCost,
    EditPleaSummaryCost,
    DeletePleaSummaryCost,
    UploadPleaSummaryCosts,
    DownloadPleaSummaryCostsModel
};